export const PHONE_DISPLAY = "+91 80972 25467";
export const PHONE_TEL = "tel:+918097225467";
export const WHATSAPP_NUMBER = "918097225467";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
export const GOOGLE_CALENDAR_URL = "https://calendar.app.google/3aoe83pF1cgdMp5Z9";

export const NAV_ITEMS = [
  { label: "About", type: "page", to: "/about" },
  { label: "Collections", type: "anchor", id: "collections" },
  { label: "Process", type: "anchor", id: "process" },
  { label: "Fabrics", type: "anchor", id: "fabrics" },
  { label: "Style Guide", type: "page", to: "/style-guide" },
  { label: "FAQ", type: "page", to: "/faq" },
  { label: "Stores", type: "page", to: "/stores" },
];

// Trust bar — factual markers only. Extend with real numbers (years, clients, Google rating) when the client provides them.
export const TRUST_ITEMS = [
  "Precision Fit",
  "In-Person, Home & Virtual Consultations",
  "WhatsApp & Video Booking",
  "2 Store Locations in Mumbai",
  "Italian & British Mills",
  "Crafted in India"
];

export const COLLECTION_CATEGORIES = [
  { id: "all", label: "All Pieces" },
  { id: "black-tie", label: "Tuxedos & Black Tie" },
  { id: "evening", label: "Evening & Embellished" },
  { id: "suits", label: "Suits & Blazers" },
];

// Real product photography from the client's zip — no AI-generated product imagery.
export const COLLECTION_ITEMS = [
  { src: "/images/products/sven-10954.jpg", name: "Ivory Peak-Lapel Tuxedo", cat: "black-tie", tall: true },
  { src: "/images/products/Sven_img_3.jpeg", name: "Noir Embellished Shawl Tuxedo", cat: "evening" },
  { src: "/images/products/Sven_img_2.jpeg", name: "Noir Embellished Shawl Tuxedo", cat: "suits" },
  { src: "/images/products/Sven_img_1.jpeg", name: "Noir Embellished Shawl Tuxedo", cat: "suits" },
  { src: "/images/products/Sven_img_4.png", name: "Riviera Sky-Blue Blazer", cat: "suits" },
  { src: "/images/products/sven-10973.jpg", name: "White Shawl-Collar Dinner Jacket", cat: "black-tie" },
  { src: "/images/products/sven-11829.jpg", name: "Constellation Evening Jacket", cat: "evening", tall: true },
  { src: "/images/products/sven-10985.jpg", name: "Midnight Jacquard Two-Piece", cat: "suits" },
  { src: "/images/products/sven-11849.jpg", name: "Navy Shawl-Lapel Tuxedo", cat: "black-tie" },
  { src: "/images/products/sven-11101.jpg", name: "Double-Breasted Corded Evening Suit", cat: "evening" },
  { src: "/images/products/sven-11276.jpg", name: "Taupe Double-Breasted Suit", cat: "suits", tall: true },
  { src: "/images/products/sven-11862.jpg", name: "Ivory Cummerbund Black-Tie Ensemble", cat: "black-tie" },
  { src: "/images/products/untitledsession1572.jpg", name: "Glacier Velvet Dinner Jacket", cat: "evening" },
];

export const PROCESS_STEPS = [
  { num: "01", title: "Consultation & Measurement", desc: "A one-on-one sitting — in store, at home, or over video. We map over thirty measurements and study posture, stance and preference." },
  { num: "02", title: "Fabric Selection", desc: "Choose from our library of wools, linens, velvets and jacquards. We advise on weight, drape and season for how you actually live." },
  { num: "03", title: "Cutting & Stitching", desc: "Your pattern is drafted for you alone. The garment is cut and stitched by hand in Mumbai — no standard blocks, no shortcuts." },
  { num: "04", title: "The Fitting", desc: "A baste fitting refines every line — collar, shoulder, sleeve pitch, trouser break — until the silhouette is unmistakably yours." },
  { num: "05", title: "Finishing & Delivery", desc: "Final hand-finishing, pressing and detailing. Your garment is delivered ready for the occasion it was made for." },
];

/*
 * FABRIC LIBRARY — TEMPORARY PLACEHOLDER SWATCH IMAGERY.
 * The client's real fabric swatch photography zip is pending upload.
 * When it arrives, replace the `img` paths below (and adjust names/specs) — the
 * picker is fully data-driven, no component changes needed.
 */
export const FABRIC_CATEGORIES = [
  {
    id: "wools",
    label: "Wools & Worsteds",
    fabrics: [
      { id: "navy-wool", name: "Navy Super 150s Worsted", img: "/images/swatches/C5036/56662-1.jpg", composition: "100% Merino Wool", weight: "260 gsm", season: "All Season", bestFor: "Business suits, wedding two-pieces" },
      { id: "charcoal-herringbone", name: "Charcoal Herringbone", img: "/images/swatches/C5037/56663-1.jpg", composition: "100% Wool", weight: "300 gsm", season: "Autumn / Winter", bestFor: "Overcoats, structured jackets" },
      { id: "grey-flannel", name: "Dove Grey Flannel", img: "/images/swatches/C5038/56551-1.jpg", composition: "Brushed Wool Flannel", weight: "310 gsm", season: "Winter", bestFor: "Soft-shoulder suits, trousers" },
      {id: "C5035", name: "Grey Barathea", img: "/images/swatches/C5035/56661-1.jpg", composition: "Wool / Mohair", weight: "290 gsm", season: "Evening", bestFor: "Tuxedos, black-tie ensembles" },
    ],
  },
  {
    id: "linens",
    label: "Linens & Summer",
    fabrics: [
      { id: "ivory-linen", name: "Ivory Pure Linen", img: "/images/swatches/ivory-linen.jpg", composition: "100% Irish Linen", weight: "240 gsm", season: "Summer", bestFor: "Day weddings, resort tailoring" },
      { id: "beige-linen", name: "Sand Linen-Wool", img: "/images/swatches/beige-linen.jpg", composition: "Linen / Wool Blend", weight: "230 gsm", season: "Spring / Summer", bestFor: "Unstructured blazers" },
    ],
  },
  {
    id: "velvets",
    label: "Velvets",
    fabrics: [
      { id: "emerald-velvet", name: "Emerald Cotton Velvet", img: "/images/swatches/emerald-velvet.jpg", composition: "100% Cotton Velvet", weight: "340 gsm", season: "Evening", bestFor: "Smoking jackets, reception wear" },
      { id: "burgundy-velvet", name: "Burgundy Velvet", img: "/images/swatches/burgundy-velvet.jpg", composition: "Cotton / Silk Velvet", weight: "330 gsm", season: "Evening", bestFor: "Dinner jackets, festive occasions" },
    ],
  },
  {
    id: "evening",
    label: "Eveningwear",
    fabrics: [
      { id: "black-barathea", name: "Jet Black Barathea", img: "/images/swatches/black-barathea.jpg", composition: "Wool / Mohair", weight: "290 gsm", season: "Evening", bestFor: "Tuxedos, black-tie ensembles" },
      { id: "gold-jacquard", name: "Antique Gold Jacquard", img: "/images/swatches/gold-jacquard.jpg", composition: "Silk Jacquard", weight: "280 gsm", season: "Ceremonial", bestFor: "Groom jackets, embellished eveningwear" },
    ],
  },
];

/*
 * PLACEHOLDER TESTIMONIALS — client to replace with real client quotes.
 * Structure is data-driven; swap objects below when real reviews arrive.
 * FUTURE UPGRADE: if the client has a Google Business Profile with reviews,
 * an embedded Google Reviews widget would be a stronger long-term option
 * than static quotes. Flagged for later — not built now.
 */
export const REVIEWS = [
  { quote: "Tailored Suit fitting is really good here. Specially shoulder and trouser fitting. I am little particular about fit but they managed it nicely.", name: "Aakash Soni", detail: "Three-Piece Wedding Suit — Santacruz" },
  { quote: "One of the most finest suits you will be wearing from this place. Extremely happy with fitting & the body shape that carves out of the suits. Finest skill for the owner & magician Aditya B from Sevn.", name: "Ashwin Nair", detail: "Midnight Tuxedo — Home Consultation" },
  { quote: "I have order them 3pc suit without telling my husband to surprise him and guess what they had take my husband size from his regular clothes and it fit perfectly my husband is very happy, i must say aditya sir is truly a genius ill surely sugges to my friends ❣️ really thakyou form bottom of my heart.", name: "Deenta Upadhyay", detail: "Dinner Jacket — Bandra" },
];

export const SERVICES = [
  "Two / Three-Piece Suit",
  "Tuxedo & Black Tie",
  "Wedding & Ceremonial",
  "Blazer & Separates",
  "Bespoke Shirts",
  "Alterations & Re-fitting",
];

export const STORES = [
  {
    id: "santacruz",
    name: "Santacruz West Atelier",
    address: "Shop No.8, Anand Shopping Center, Swami Vivekanand Rd, near Asha Parekh Hospital, Navyug Colony, Santacruz (West), Mumbai, Maharashtra 400054",
    hours: "11:00 AM – 9:00 PM · Open Daily",
    mapQuery: "Asha Parekh Hospital, Swami Vivekanand Rd, Santacruz West, Mumbai, Maharashtra 400054",
  },
  {
    id: "bandra",
    name: "Bandra West Atelier",
    address: "Shop No.1, Deccan Court, 259/1, Swami Vivekanand Rd, Bandra West, Mumbai, Maharashtra 400050",
    hours: "11:00 AM – 9:00 PM · Open Daily",
    mapQuery: "Deccan Court, 259/1, Swami Vivekanand Rd, Bandra West, Mumbai 400050",
  },
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

/*
 * ANATOMY SECTION — PLACEHOLDER CONSTRUCTION CLAIMS.
 * These are generic bespoke-tailoring claims for layout purposes only —
 * NOT verified facts about how Sven actually builds a jacket.
 * CONFIRM with the client before launch, especially "Full Canvas
 * Construction" and "Hand-Sewn Buttonholes" — claims a customer could
 * verify by feel. Swap the title/desc strings below when confirmed;
 * no component changes needed.
 */
export const ANATOMY_IMAGE = "/images/products/anatomy_image.png";

export const ANATOMY_POINTS = [
  {
    id: "canvas",
    top: "27%",
    left: "5%",
    align: "left",
    title: "Full Canvas Construction",
    desc: "A full internal canvas, not a fused lining, lets the jacket mould to the body over time and hold its shape for years.",
  },
  {
    id: "lapel",
    top: "18%",
    left: "60%",
    align: "left",
    title: "Hand-Finished Lapels",
    desc: "Lapel edges are pressed and finished by hand for a roll that stays crisp, not stiff.",
  },
  {
    id: "shoulder",
    top: "52%",
    left: "5%",
    align: "left",
    title: "Structured Shoulder, Natural Drape",
    desc: "Built with a soft shoulder roll for a natural line rather than a padded, boxy silhouette.",
  },
  {
    id: "buttonholes",
    top: "60%",
    left: "60%",
    align: "left",
    title: "Hand-Sewn Buttonholes",
    desc: "Working buttonholes are finished by hand — a small detail that signals real bespoke construction.",
  },
];

export const ANATOMY_SIZE_RANGE = "Available in Sizes XS – 6XL";